import React from 'react';
import ClientRowProperties from "./ClientRowProperties";
import ViewMedium from "../../../ui_components/MediaView/ViewMedium";
import ClientRowMedium from "./ClientRowMedium";
import ViewLarge from "../../../ui_components/MediaView/ViewLarge";
import ViewSmall from "../../../ui_components/MediaView/ViewSmall";
import ClientRowSmall from "./ClientRowSmall";


const ClientRow: React.FC<ClientRowProperties> = ({
                                                      client,
                                                      selected,
                                                      onUpdate,
                                                      onClientSelect,
                                                  }) => {
    return (
        <>
            <ViewSmall>
                <ClientRowSmall onUpdate={onUpdate} client={client} onClientSelect={onClientSelect} selected={selected} />
            </ViewSmall>
            <ViewMedium>
                <ClientRowMedium onUpdate={onUpdate} client={client} onClientSelect={onClientSelect} selected={selected} />
            </ViewMedium>
            <ViewLarge>
                <ClientRowMedium onUpdate={onUpdate} client={client} onClientSelect={onClientSelect} selected={selected} />
            </ViewLarge>
        </>
    )
}

export default ClientRow;
